import React from "react";

import "./styles/outsideWork.css";

// Personal layer for the About page. Each item doubles as a character signal:
// mentorship (generosity), community and volunteering (showing up for others),
// running and boxing (discipline and composure). Kept warm and specific.
const OutsideWork = () => (
	<div className="outside-work">
		<h3 className="outside-work-title">Outside the work</h3>

		<p>The work is only half the story.</p>

		<p>
			I mentor students at NYU, mostly engineers and data folks still
			finding their footing. I came to this country with more questions
			than answers, and the people who gave me their time changed where I
			ended up. Paying that forward is not charity. It is the most
			leveraged thing I do.
		</p>

		<p>
			I also organize and volunteer with groups building a real path for
			immigrant and Asian American professionals in tech. The network
			that carried me was built by people who showed up for strangers. I
			try to be one of those people now.
		</p>

		<p>
			Two disciplines keep me honest, and neither one cares about my
			title. Distance running, where the last three miles are won by
			simply not stopping. And boxing, which teaches you fast that
			composure under pressure is a skill you practice, not a mood you
			wait for.
		</p>

		<p>
			None of this is separate from how I lead. Patience with people,
			showing up when it is hard, staying calm when it counts. I learned
			as much of that on the road and in the ring as I did in any
			standup.
		</p>
	</div>
);

export default OutsideWork;
